import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './photoCarouselStyling';
import ForwardArrow from './Images/arrow_forward';
import BackArrow from './Images/arrow_back';

const DocumentCarousel = ({ idx, src }) => {
  const [activeIdx, setActiveIdx] = useState(0);
  const arrOfFiles = src.Photos;
  const idxOfFile = idx;
  const findIndex = arrOfFiles.findIndex(item => item.id === idxOfFile);

  useEffect(() => {
    setActiveIdx(idx ? findIndex : 0);
    document.getElementById(`imgId_${arrOfFiles[0].id}`).style.border = '2px solid red';
  }, []);

  const updateIdx = (newIdx) => {
    const getAllElements = document.querySelectorAll("[id^='imgId_']");
    let index = newIdx;
    if (index < 0) index = 0;
    else if (index >= arrOfFiles.length) index = arrOfFiles.length - 1;
    setActiveIdx(index);

    getAllElements.forEach((img) => {
      const i = img;
      i.style.border = '';
    });
    document.getElementById(`imgId_${arrOfFiles[newIdx].id}`).style.border = '2px solid red';
  };

  const goToSlide = (id) => {
    const newidx = arrOfFiles.findIndex(file => file.id === id);
    const getAllElements = document.querySelectorAll("[id^='imgId_']");
    setActiveIdx(newidx);

    getAllElements.forEach((img) => {
      const i = img;
      i.style.border = '';
    });
    document.getElementById(`imgId_${id}`).style.border = '2px solid red';
  };


  return (
    <div className={s.container}>
      {/* eslint jsx-a11y/no-static-element-interactions: 0 */}
      <img alt="left_arrow" src={BackArrow} className={s.leftButton} onClick={() => { updateIdx(activeIdx - 1); }} />
      <img alt="right_arrow" src={ForwardArrow} className={s.rightButton} onClick={() => { updateIdx(activeIdx + 1); }} />
      <h4 className={s.docName}>{arrOfFiles[activeIdx].document_name}</h4>
      <div
        className={s.backgroundImg}
        style={{
          backgroundImage: `url(${arrOfFiles[activeIdx].expiring_download_url})`,
        }}
      />
      <div style={{ textAlign: 'center', paddingTop: '10px', display: 'flex', overflow: 'auto', justifyContent: 'center' }}>
        {arrOfFiles.map(file => <img id={`imgId_${file.id}`} key={file.id} className={s.bottomCarousel} onClick={() => goToSlide(file.id)} src={file.expiring_download_url} alt="unchecked" />)}
      </div>
    </div>
  );
};

DocumentCarousel.propTypes = {
  idx: PropTypes.number.isRequired,
  src: PropTypes.object.isRequired,
};

export default DocumentCarousel;



// WEBPACK FOOTER //
// ./client/app/shared/components/DocumentsTable/carousel.jsx